import { render, staticRenderFns } from "./GoogleLoginComponent.vue?vue&type=template&id=548e0bea&scoped=true"
import script from "./GoogleLoginComponent.vue?vue&type=script&lang=js"
export * from "./GoogleLoginComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e0bea",
  null
  
)

export default component.exports